export default __webpack_public_path__ + "static/zaru_collages_v6-2-8661a261731fd9318b920ba2836b0c08.png";